var map = {
	"./about.png": "FhzR",
	"./about01.png": "UY0n",
	"./about02.png": "OsSo",
	"./association.png": "AMAK",
	"./contact-banner.png": "Va8t",
	"./contact-msg.png": "7MdT",
	"./contact.png": "EJVn",
	"./contact02.png": "6B8r",
	"./home-mobile.png": "gkuw",
	"./home.png": "KSZv",
	"./index-logo.png": "XQoL",
	"./info-bg.png": "UHi1",
	"./ir.png": "n7pe",
	"./logo.png": "iQH9",
	"./menu.png": "F3CK",
	"./news.png": "v24n",
	"./product.png": "E38b",
	"./qcode.png": "Zdpu",
	"./tel.png": "+eg0",
	"./top.png": "IR8c",
	"./wx.png": "ZDm/",
	"./首页2.png": "0p55",
	"./首页3.png": "BdTU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 2